import { render, staticRenderFns } from "./ImageCard.vue?vue&type=template&id=484f24b8&lang=pug&"
import script from "./ImageCard.vue?vue&type=script&lang=ts&"
export * from "./ImageCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484f24b8')) {
      api.createRecord('484f24b8', component.options)
    } else {
      api.reload('484f24b8', component.options)
    }
    module.hot.accept("./ImageCard.vue?vue&type=template&id=484f24b8&lang=pug&", function () {
      api.rerender('484f24b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cvtool-pages/ImageCard.vue"
export default component.exports